/* eslint-disable @typescript-eslint/indent */
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)

type MonthNumber = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12

export function formatDateToYYYYMMDD(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0') // Months are 0-based
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}

export const makeDate = (timestamp: number | string) => {
  const options: any = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }

  if (typeof timestamp === 'string') {
    let d = dayjs(timestamp, 'DD.MM.YYYY')
    if (!d.isValid()) d = dayjs(timestamp, 'YYYY-MM-DD')
    return d.isValid()
      ? d.toDate().toLocaleString(undefined, options)
      : timestamp
  }

  return new Date(timestamp).toLocaleString(undefined, options)
}

export const makeAlphaDate = (timestamp: number) => {
  const options: any = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
    // You can also specify other options like timeZoneName, hour12, etc. as needed.
  }

  return new Date(timestamp).toLocaleString(undefined, options)
}

export function getAge(birthDate: string): string {
  if (!birthDate) return ''

  const birth = dayjs(birthDate, 'DD.MM.YYYY')
  const now = dayjs()

  const years = now.diff(birth, 'years')
  const months = now.diff(birth.add(years, 'years'), 'months')
  const days = now.diff(birth.add(years, 'years').add(months, 'months'), 'days')

  return `${years}y, ${months}m, ${days}d`
}

export function getAgeAtDate(birthMoment: string, dateMoment: number): string {
  let cleanedBirthMoment = dayjs(birthMoment, 'DD.MM.YYYY')
  const cleanedDateMoment = dayjs(dateMoment)

  const years = cleanedDateMoment.diff(cleanedBirthMoment, 'years')
  cleanedBirthMoment = cleanedBirthMoment.add(years, 'years')

  const months = cleanedDateMoment.diff(cleanedBirthMoment, 'months')
  cleanedBirthMoment = cleanedBirthMoment.add(months, 'months')

  const days = cleanedDateMoment.diff(cleanedBirthMoment, 'days')

  return `${years}y, ${months}m, ${days}d`
}

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
]

export function getCurrentYear(): `20${number}` {
  const date = new Date()
  return date.getUTCFullYear() as unknown as `20${number}`
}

export function getCurrentMonthNumber() {
  const date = new Date()
  return (date.getUTCMonth() + 1) as MonthNumber
}

export function getLastMonthNumber() {
  const currentMonth = getCurrentMonthNumber()
  return currentMonth === 1 ? 12 : ((currentMonth - 1) as MonthNumber)
}

export function getCurrentMonthName() {
  const date = new Date()
  return monthNames[date.getUTCMonth()]
}

// this function returns true if the date input is older than midnight of the current day (beginning of the day)
export function isOutdatedDate(todayDate: number): boolean {
  const inputDate = new Date(todayDate)
  const currentDate = new Date()

  // Set the time to midnight for both dates to compare only the date part
  inputDate.setHours(0, 0, 0, 0)
  currentDate.setHours(0, 0, 0, 0)

  return inputDate < currentDate
}

export function differenceBetweenTodayAndDate(timestamp: number): number {
  const inputDate = new Date(timestamp)
  const currentDate = new Date()

  // Calculate the difference in time
  const timeDifference = inputDate.getTime() - currentDate.getTime()

  // Convert time difference from milliseconds to days
  return Math.ceil(timeDifference / (1000 * 3600 * 24))
}

export function isLessThanFourteenDaysLeft(timestamp: number): boolean {
  return differenceBetweenTodayAndDate(timestamp) <= 14
}
